module.exports = __webpack_public_path__ + "media/images/icons/x_circle-47b7e3f2cd567da66b51a1b7ed030904.svg";